<template>
  <div>
    <template v-if="!hide">
      <!-- <span v-if="auth && auth.canEdit">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-icon
              style="font-size: 20px"
              color="info"
              v-on="on"
              @click.stop="goTo(`/auditorias/${params.data.uuid}`)"
              >mdi-eye-outline</v-icon
            >
          </template>
          <span>Ver</span>
        </v-tooltip>
      </span> -->
        <span v-if="auth && auth.canClose && isOpen">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-icon
              style="font-size: 20px"
              color="success"
              v-on="on"
              @click.stop="confirmClose = true"
              >mdi-check-circle-outline</v-icon
            >
          </template>
          <span>Cerrar</span>
        </v-tooltip>
      </span>
      <span v-if="auth && auth.canOpen && isClosed">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-icon
              style="font-size: 20px"
              color="success"
              v-on="on"
              @click.stop="openItem()"
              >mdi-open-in-new</v-icon
            >
          </template>
          <span>Abrir</span>
        </v-tooltip>
      </span>
      <span v-if="auth && auth.canDelete && canDelete">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-icon
              style="font-size: 20px"
              color="error"
              v-on="on"
              @click.stop="confirmDelete = true"
              >mdi-delete-outline</v-icon
            >
          </template>
          <span>Borrar</span>
        </v-tooltip>
      </span>
    
    </template>

    <!-- Confirmación -->

    <confirmation
      v-model="confirmDelete"
      :text="'¿Eliminar auditoria?'"
      colorButton="error"
      @confirm="deleteItem()" />

    <confirmation
      v-model="confirmClose"
      :text="'Se debe cerrar la auditoría cuando el checklist, pacs, y muestras estén realizados totalmente. No se podrá volver a abrir ¿Está seguro de cerrar la auditoría?'"
      colorButton="error"
      textButton="Cerrar"
      @confirm="closeItem()" />
      
  </div>
</template>

<script>
import Confirmation from '~/components/Confirmation'

export default {
  components: {
    Confirmation,
  },
  data() {
    return {
      confirmDelete: false,
      confirmClose: false,
      auth: {},
    }
  },
  computed: {
    isOpen() {
      return this.params.data.estado == 'ABIERTA'
    },
    isClosed() {
      return this.params.data.estado == 'REALIZADA' || this.params.data.estado == 'CERRADA'
    },
    canDelete() {
      return true
    },
    hide() {
      return this.params.value === true
    },
  },
  methods: {
    init() {
      if (this.params.init instanceof Function) this.params.init()
    },
    async deleteItem() {
      this.confirmDelete = false
      const auditoria = this.params?.node?.data
      const gridApi = this.$parent.gridOptions.api
      const result = await this.$store.dispatch('auditorias/delete', auditoria)
      console.log('deleteAuditoria responseBack', result?.status, result?.message, result?.response)

      if (result?.ok) {
        console.log('gridApi', gridApi)
        gridApi.purgeServerSideCache()
        gridApi.refreshCells()
        this.$store.commit('notification/show', {
          text: 'Auditoria eliminada correctamente',
          color: 'success',
          timeout: 3000,
        })
        this.init()
        return
      }

      this.$store.commit('notification/show', {
        text: result?.message || 'No se pudo eliminar la auditoría',
        color: 'error',
        timeout: 5000,
      })
    },
    async closeItem() {
      this.confirmClose = false
      const gridApi = this.$parent.gridOptions.api
      this.params.node.data.estado = 'CERRADA'
      if (this.params.node.data.uuid) {
        await this.$store.dispatch(`auditorias/cambiarEstado`, this.params.node.data).then(() => {
          console.log('gridApi', gridApi)
          gridApi.purgeServerSideCache()
          gridApi.refreshCells()
          this.$store.commit('notification/show', {
            text: 'Auditoria cerrada correctamente',
            color: 'success',
            timeout: 3000,
          })
        })
        this.init()
      }
    },
    async openItem() {
      this.confirmClose = false
      const gridApi = this.$parent.gridOptions.api
      this.params.node.data.estado = 'ABIERTA'
      if (this.params.node.data.uuid) {
        await this.$store.dispatch(`auditorias/cambiarEstado`, this.params.node.data).then(() => {
          console.log('gridApi', gridApi)
          gridApi.purgeServerSideCache()
          gridApi.refreshCells()
          this.$store.commit('notification/show', {
            text: 'Auditoria abierta correctamente',
            color: 'success',
            timeout: 3000,
          })
        })
        this.init()
      }
    },
    async checkRoles() {
      this.auth = await this.$store.dispatch('user/can', {
        module: 'auditorias',
        submodule: 'auditorias',
        return: 'all',
      })
      console.log('auth', this.auth)
    },
  },

  async mounted() {
    this.checkRoles()
  },
}
</script>
